import { useState } from 'react';

import { useQuery } from 'react-query';

import { loadGadgets } from 'helpers/services/services.gadgets';

const INITIAL_STATE = { custom: [], list: [] };

export function useLoadgadgets(s1gadgets: { CODE: string }[]) {
  const [gadgets, setGadgets] = useState(INITIAL_STATE);
  const codes = s1gadgets.map((item: any) => item.CODE).toString();

  const query = useQuery(['gadgets', { codes }], loadGadgets, {
    retry: false,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      const dataEntries = Object.entries(data.gadgets ?? {});
      const newData = dataEntries.reduce((acc: any, [key, rawValue]) => {
        const value = rawValue as any;
        const dataKeys = Object.keys(value.data);
        const description =
          value.description ??
          value.config?.title ??
          value.data?.title ??
          value.name ??
          '';
        const enriched = { key, ...value, description };
        if (dataKeys.some((dataKey) => dataKey === 'LIST')) {
          return { ...acc, list: [...acc['list'], enriched] };
        }
        return { ...acc, custom: [...acc['custom'], enriched] };
      }, INITIAL_STATE);
      setGadgets(newData);
    },
  });

  return { ...query, data: gadgets };
}
